"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("antd/es/spin/style");

var _spin = _interopRequireDefault(require("antd/es/spin"));

require("antd/es/popover/style");

var _popover = _interopRequireDefault(require("antd/es/popover"));

require("antd/es/row/style");

var _row = _interopRequireDefault(require("antd/es/row"));

require("antd/es/tooltip/style");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

require("antd/es/button/style");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/col/style");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/modal/style");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/message/style");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

var _react = _interopRequireDefault(require("react"));

var _reactSwitch = _interopRequireDefault(require("react-switch"));

var _intlTools = require("@nackle/intl-tools");

var _icons = require("./shared/icons/icons.js");

var _reactColor = require("react-color");

var _html2canvas = _interopRequireDefault(require("html2canvas"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _emojiPickerReact = _interopRequireDefault(require("emoji-picker-react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFadeIn = _interopRequireDefault(require("react-fade-in"));

var _content = _interopRequireDefault(require("./content.js"));

var _ecards = _interopRequireDefault(require("./ecards.js"));

var _constants = require("./constants.js");

var _endpoints = require("./endpoints.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Editor = /*#__PURE__*/function (_React$Component) {
  _inherits(Editor, _React$Component);

  var _super = _createSuper(Editor);

  function Editor(props) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "imageLoaded", function () {
      _this.setState({
        imageLoaded: true
      });

      var height = _this.imageRef.current.height;
      var shiftAmount = '0px';

      if (height > 465) {
        var difference = height - 465;
        shiftAmount = "-".concat(difference / 2, "px");
      }

      _this.imageRef.current.style.transform = "translateY(".concat(shiftAmount, ")");
    });

    _defineProperty(_assertThisInitialized(_this), "dropRejected", function (rejections) {
      rejections.map(function (rejection) {
        rejection.errors.map(function (error) {
          if (error.code === 'file-too-large') {
            _message2.default.error((0, _intlTools.getString)('ecard.customize.uploadTooBig'));
          }

          if (error.code === 'file-invalid-type') {
            _message2.default.error((0, _intlTools.getString)('ecard.customize.uploadUnsupportedFile'));
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "imageDrop", function (files) {
      var _this$props = _this.props,
          token = _this$props.token,
          locale = _this$props.locale,
          onError = _this$props.onError;

      if (files && files.length > 0) {
        _this.setState({
          imageSaving: true
        });

        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.addEventListener('loadend', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
            var saved;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _ecards.default)(token, reader.result, locale);

                  case 2:
                    saved = _context.sent;

                    if (!(saved.errors && typeof onError === 'function')) {
                      _context.next = 7;
                      break;
                    }

                    onError(saved.errors);

                    _this.setState({
                      imageSaving: false
                    });

                    return _context.abrupt("return");

                  case 7:
                    _this.setState({
                      selectedEcard: saved,
                      showEcards: true,
                      showDropzone: false,
                      isUpload: true,
                      imageSaving: false
                    });

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(), false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "directSelectEcard", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(option) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.selectEcard(option);

              case 2:
                _this.saveImage();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setEcardRef", function (el) {
      if (!el) {
        return;
      }

      _this.ecardMessageRef = el;

      _this.ecardMessageRef.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "fetchContent", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(count) {
        var _this$props2, token, locale, showEcards, success;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props2 = _this.props, token = _this$props2.token, locale = _this$props2.locale;
                showEcards = _this.state.showEcards;
                _context3.next = 4;
                return (0, _content.default)(token, 'ecard-editor', locale);

              case 4:
                success = _context3.sent;

                if (success.success) {
                  _this.setState({
                    showEcards: showEcards
                  });
                } else if (!success.success && parseInt(count) < 5) {
                  _this.fetchContent(count + 1);
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleEcardPicker", function () {
      var onVisibilityChange = _this.props.onVisibilityChange;
      var showEcards = _this.state.showEcards;

      _this.setState({
        showEcards: !showEcards
      });

      if (typeof onVisibilityChange === 'function') {
        onVisibilityChange(!showEcards);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectEcard", function (ecard) {
      _this.setState({
        selectedEcard: ecard.ecard
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deselectEcard", function () {
      var _this$props3 = _this.props,
          setEcardImage = _this$props3.setEcardImage,
          onEcardRemoved = _this$props3.onEcardRemoved;

      _this.setState({
        selectedEcard: '',
        editingText: false,
        ecardText: '',
        fontFamily: 'Poppins',
        fontWeight: 600,
        backgroundColor: 'rgba(245, 247, 250, 0.5)',
        textColor: '#000000',
        imageLoaded: false,
        isUpload: false,
        saved: false
      });

      if (typeof onEcardRemoved === 'function') {
        onEcardRemoved();
      }

      setEcardImage('');
    });

    _defineProperty(_assertThisInitialized(_this), "handleColorChange", function (color) {
      if (color.hex === '#f5f7fa' || color.hex === '#b1baca') {
        _this.setState({
          backgroundColor: 'rgba( 0, 0, 0, 0.5 )'
        });
      } else {
        _this.setState({
          backgroundColor: 'rgba(245, 247, 250, 0.5)'
        });
      }

      var originalColor = color;

      _this.setState({
        textColor: color.hex,
        originalColor: originalColor
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackgroundColorChange", function (color) {
      var textColor = '#fff';

      if (color.hex === '#f5f7fa') {
        textColor = '#000';
      }

      var originalColor = color;
      var rgb = color.rgb;

      if (rgb.a > 0) {
        rgb.a = 0.5;
      }

      _this.setState({
        backgroundColor: "rgba(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ", ").concat(rgb.a, ")"),
        textColor: textColor,
        originalColor: originalColor
      });
    });

    _defineProperty(_assertThisInitialized(_this), "trackCursor", function (event) {
      var cursor = _this.getCaretPosition(event.target);

      _this.setState({
        ecardCursor: cursor
      });
    });

    _defineProperty(_assertThisInitialized(_this), "triggerPicker", function () {
      var pickerVisible = _this.state.pickerVisible;

      _this.setState({
        pickerVisible: !pickerVisible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "triggerEcardEmojiPicker", function () {
      var ecardEmojiPickerVisible = _this.state.ecardEmojiPickerVisible;

      _this.setState({
        ecardEmojiPickerVisible: !ecardEmojiPickerVisible
      });

      setTimeout(function () {
        _this.setState({
          showEcardEmojis: true
        });

        var search = document.getElementsByClassName('emoji-search');

        if (search && search.length > 0) {
          search[0].setAttribute('placeholder', (0, _intlTools.getString)('ecard.emoji.search'));
        }
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "emojiCardClick", function (event, emoji) {
      var _this$state = _this.state,
          ecardCursor = _this$state.ecardCursor,
          ecardText = _this$state.ecardText; // figure out how many cursor positions to move after inserting

      var emojiBits = emoji.unified.split('-');
      var bitsCount = emojiBits.length;
      var shiftOver = bitsCount * 2;

      if (!ecardText) {
        _this.ecardMessageRef.innerText = "".concat(emoji.emoji);

        _this.setState({
          ecardText: "".concat(emoji.emoji)
        });

        if (emoji.unified.length > 5) {
          _this.setState({
            ecardCursor: shiftOver
          });
        } else {
          _this.setState({
            ecardCursor: 2
          });
        }
      } else if (ecardCursor !== undefined) {
        var messageFront = ecardText.slice(0, ecardCursor);
        var messageBack = ecardText.slice(ecardCursor);
        var updatedMessage = "".concat(messageFront).concat(emoji.emoji).concat(messageBack);
        _this.ecardMessageRef.innerText = updatedMessage;

        _this.setState({
          ecardText: updatedMessage
        });

        if (emoji.unified.length > 5) {
          _this.setState({
            ecardCursor: ecardCursor + shiftOver
          });
        } else {
          _this.setState({
            ecardCursor: ecardCursor + 2
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTextEdit", function () {
      var editingText = _this.state.editingText;

      if (!editingText) {
        if (_this.setEcardRef && _this.setEcardRef.current) {
          _this.setEcardRef.current.focus();
        }
      }

      _this.setState({
        editingText: !editingText
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleBackground", function (backgroundSelected) {
      var _this$state2 = _this.state,
          backgroundColor = _this$state2.backgroundColor,
          originalColor = _this$state2.originalColor;

      if (backgroundSelected) {
        var textColor = '#ffffff';

        if (backgroundColor === 'rgba(245, 247, 250, 0.5)' && (!originalColor || originalColor.hex === '#f5f7fa')) {
          textColor = '#000000';
        }

        var rgb;

        if (originalColor) {
          rgb = originalColor.rgb;

          if (rgb.a > 0) {
            rgb.a = 0.5;
          }
        }

        if (backgroundColor === 'rgba( 0, 0, 0, 0.5 )') {
          textColor = '#000000';
        }

        _this.setState({
          textBackgroundSelected: true,
          textColor: textColor,
          backgroundColor: rgb ? "rgba(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ", ").concat(rgb.a, ")") : 'rgba(245, 247, 250, 0.5)'
        });
      } else {
        var nextColor = '#ffffff';
        var newBackground = 'rgba(245, 247, 250, 0.5)';

        if (backgroundColor !== 'rgba(245, 247, 250, 0.5)') {
          nextColor = originalColor.hex;
        } else {
          nextColor = '#000000';
        }

        _this.setState({
          textBackgroundSelected: false,
          textColor: nextColor,
          backgroundColor: newBackground
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "change", function (event) {
      _this.setState({
        ecardText: event.target.innerText
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleWindowMouseOrTouch", function (e) {
      var showEcards = _this.state.showEcards;

      if (_this.popupRef && _this.popupRef.current) {
        if (!_this.popupRef.current.contains(e.target)) {
          _this.setState({
            pickerVisible: false
          });
        }
      }

      if (_this.ecardEmojiPickerRef && _this.ecardEmojiPickerRef.current && showEcards) {
        if (!_this.ecardEmojiPickerRef.current.contains(e.target)) {
          _this.setState({
            ecardEmojiPickerVisible: false,
            showEcardEmojis: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCaretPosition", function (editableDiv) {
      var caretPos = 0,
          sel,
          range;

      if (window.getSelection) {
        sel = window.getSelection();

        if (sel.rangeCount) {
          range = sel.getRangeAt(0);

          if (range.commonAncestorContainer.parentNode == editableDiv) {
            caretPos = range.endOffset;
          }
        }
      } else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();

        if (range.parentElement() == editableDiv) {
          var tempEl = document.createElement('span');
          editableDiv.insertBefore(tempEl, editableDiv.firstChild);
          var tempRange = range.duplicate();
          tempRange.moveToElementText(tempEl);
          tempRange.setEndPoint('EndToEnd', range);
          caretPos = tempRange.text.length;
        }
      }

      return caretPos;
    });

    _defineProperty(_assertThisInitialized(_this), "changeFont", function (style) {
      switch (style) {
        case 'casual':
          _this.setState({
            fontFamily: 'Poppins',
            fontWeight: 600
          });

          return;

        case 'formal':
          _this.setState({
            fontFamily: 'Lora',
            fontWeight: 500
          });

          return;

        case 'strong':
          _this.setState({
            fontFamily: 'Oswald',
            fontWeight: 600
          });

          return;

        case 'personal':
          _this.setState({
            fontFamily: 'Gochi Hand',
            fontWeight: 400
          });

          return;

        case 'playful':
          _this.setState({
            fontFamily: 'Pattaya',
            fontWeight: 400
          });

          return;

        default:
          _this.setState({
            fontFamily: 'Poppins',
            fontWeight: 600
          });

          return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "deletePrompt", function () {
      _modal.default.confirm({
        title: /*#__PURE__*/_react.default.createElement("div", {
          className: "title-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-flex"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-circle"
        }, /*#__PURE__*/_react.default.createElement(_icons.Garbage, {
          fill: "#ffffff"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "title-text"
        }, _this.state.saved ? 'Discard changes?' : (0, _intlTools.getString)('ecard.customize.deleteTitle'))),
        content: _this.state.saved ? /*#__PURE__*/_react.default.createElement("div", {
          className: "delete-content"
        }, "Are you sure you want to discard changes?") : /*#__PURE__*/_react.default.createElement("div", {
          className: "delete-content"
        }, (0, _intlTools.getString)('ecard.customize.deleteText')),
        onOk: !_this.state.saved ? function () {
          return _this.deselectEcard();
        } : function () {
          _this.props.setEcardImage(_this.state.savedEcard);

          _this.setState({
            ecardText: '',
            fontFamily: 'Poppins',
            fontWeight: 600,
            backgroundColor: 'rgba(245, 247, 250, 0.5)',
            textColor: '#000000',
            imageLoaded: false,
            isUpload: false,
            showEcards: false,
            saved: false
          });

          _this.props.onVisibilityChange(false);
        },
        okText: _this.state.saved ? 'Discard' : (0, _intlTools.getString)('ecard.customize.deleteButton'),
        destroyOnClose: true,
        icon: '',
        className: 'delete-modal',
        okButtonProps: {
          danger: true
        },
        getContainer: function getContainer() {
          return _this.renderRef.current;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropzone", function () {
      var _this$state3 = _this.state,
          showDropzone = _this$state3.showDropzone,
          showEcards = _this$state3.showEcards;
      var onVisibilityChange = _this.props.onVisibilityChange;

      _this.setState({
        showDropzone: !showDropzone
      });

      if (typeof onVisibilityChange === 'function') {
        if (!showEcards && !showDropzone) {
          onVisibilityChange(true);
        } else if (showDropzone && !showEcards) {
          onVisibilityChange(false);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveImage", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _this$props4, setEcardImage, onVisibilityChange, locale, token, onError, onSave, _this$state4, selectedEcard, ecardText, textColor, backgroundColor, fontFamily, fontWeight, canvas, dataUrl, originalUrl, originalData, metadata, saved;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props4 = _this.props, setEcardImage = _this$props4.setEcardImage, onVisibilityChange = _this$props4.onVisibilityChange, locale = _this$props4.locale, token = _this$props4.token, onError = _this$props4.onError, onSave = _this$props4.onSave;
              _this$state4 = _this.state, selectedEcard = _this$state4.selectedEcard, ecardText = _this$state4.ecardText, textColor = _this$state4.textColor, backgroundColor = _this$state4.backgroundColor, fontFamily = _this$state4.fontFamily, fontWeight = _this$state4.fontWeight;

              _this.setState({
                saving: true
              });

              if (!(ecardText && ecardText.length > 0)) {
                _context4.next = 23;
                break;
              }

              _context4.next = 6;
              return (0, _html2canvas.default)(_this.renderRef.current, {
                imageTimeout: 0,
                useCORS: true
              });

            case 6:
              canvas = _context4.sent;
              dataUrl = canvas.toDataURL('image/jpeg');
              originalUrl = '';
              originalData = '';

              if (selectedEcard && selectedEcard.images && selectedEcard.images.length > 0) {
                if (selectedEcard.images[0].url) {
                  originalUrl = selectedEcard.images[0].url;
                } else if (selectedEcard.images[0].data) {
                  originalData = selectedEcard.images[0].data;
                }
              }

              metadata = {
                // customText: ecardText,
                customTextStyle: {
                  textColor: textColor,
                  backgroundColor: backgroundColor,
                  fontFamily: fontFamily,
                  fontWeight: fontWeight
                },
                stickers: [],
                originalUrl: originalUrl,
                originalData: originalData
              };
              _context4.next = 14;
              return (0, _ecards.default)(token, dataUrl, locale, metadata);

            case 14:
              saved = _context4.sent;

              if (!(saved.errors && typeof onError === 'function')) {
                _context4.next = 19;
                break;
              }

              onError(saved.errors);

              _this.setState({
                saving: false
              });

              return _context4.abrupt("return");

            case 19:
              setEcardImage(saved);

              _this.setState({
                savedEcard: saved
              });

              _context4.next = 24;
              break;

            case 23:
              setEcardImage(selectedEcard);

            case 24:
              if (typeof onSave === 'function') {
                onSave(_this.state);
              }

              if (typeof onVisibilityChange === 'function') {
                onVisibilityChange(false);
              }

              _this.setState({
                showEcards: false,
                saving: false,
                saved: true
              });

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _this.state = {
      showEcards: false,
      textColor: '#000000',
      pickerVisible: false,
      editingText: false,
      textBackgroundSelected: true,
      backgroundColor: 'rgba(245, 247, 250, 0.5)',
      fontFamily: 'Poppins',
      fontWeight: 600,
      showDropzone: false,
      ecardEmojiPickerVisible: false,
      showEcardEmojis: false,
      saving: false,
      imageLoaded: false,
      isUpload: false,
      imageSaving: false,
      refUpdated: false,
      saved: false
    };
    _this.popupRef = /*#__PURE__*/_react.default.createRef();
    _this.ecardMessageRef = /*#__PURE__*/_react.default.createRef();
    _this.renderRef = /*#__PURE__*/_react.default.createRef();
    _this.ecardEmojiPickerRef = /*#__PURE__*/_react.default.createRef();
    _this.pickerButtonRef = /*#__PURE__*/_react.default.createRef();
    _this.imageRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  _createClass(Editor, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.fetchContent(0);

              case 2:
                window.addEventListener('touchstart', this.handleWindowMouseOrTouch);
                window.addEventListener('mousedown', this.handleWindowMouseOrTouch);

                if (this.props.ecardState && this.props.ecardState.ecardText && this.props.ecardState.selectedEcard && !this.state.refUpdated) {
                  this.ecardMessageRef.innerText = this.props.ecardState.ecardText;
                  this.setState({
                    refUpdated: true
                  });
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('touchstart', this.handleWindowMouseOrTouch);
      window.removeEventListener('mousedown', this.handleWindowMouseOrTouch);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2,
          _this2 = this;

      var _this$props5 = this.props,
          ecards = _this$props5.ecards,
          uploadDrawerClass = _this$props5.uploadDrawerClass,
          drawerClass = _this$props5.drawerClass,
          className = _this$props5.className,
          locale = _this$props5.locale,
          companyId = _this$props5.companyId,
          handleKeyPress = _this$props5.handleKeyPress,
          hideCustomization = _this$props5.hideCustomization,
          ecardRequired = _this$props5.ecardRequired;
      var _this$state5 = this.state,
          showEcards = _this$state5.showEcards,
          showDropzone = _this$state5.showDropzone,
          selectedEcard = _this$state5.selectedEcard,
          textColor = _this$state5.textColor,
          pickerVisible = _this$state5.pickerVisible,
          editingText = _this$state5.editingText,
          textBackgroundSelected = _this$state5.textBackgroundSelected,
          backgroundColor = _this$state5.backgroundColor,
          fontFamily = _this$state5.fontFamily,
          fontWeight = _this$state5.fontWeight,
          ecardText = _this$state5.ecardText,
          ecardEmojiPickerVisible = _this$state5.ecardEmojiPickerVisible,
          showEcardEmojis = _this$state5.showEcardEmojis,
          saving = _this$state5.saving,
          imageLoaded = _this$state5.imageLoaded,
          isUpload = _this$state5.isUpload;
      var allowUpload = false;
      var allowCustomText = false;

      if (ecards && ecards.length > 0 && ecards[0].reward) {
        allowUpload = ecards[0].reward.allowUpload;
        allowCustomText = ecards[0].reward.allowCustomText;
      }

      if (hideCustomization) {
        allowCustomText = false;
      }

      var drawerClasses = (0, _classnames.default)(_defineProperty({
        open: showDropzone ? false : showEcards ? true : false,
        'ecard-drawer': true
      }, drawerClass, drawerClass ? true : false));
      var ecardTextClasses = (0, _classnames.default)({
        'ecard-text': true,
        'background-visible': textBackgroundSelected
      });
      var uploadDrawerClasses = (0, _classnames.default)((_classNames2 = {
        'upload-drawer': true,
        open: showDropzone
      }, _defineProperty(_classNames2, uploadDrawerClass, uploadDrawerClass ? true : false), _defineProperty(_classNames2, 'hidden', hideCustomization && !showDropzone ? true : false), _classNames2));
      var componentClasses = (0, _classnames.default)(_defineProperty({
        'bottom-btn-container': true
      }, className, className ? true : false));
      return /*#__PURE__*/_react.default.createElement(_row.default, {
        className: componentClasses
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 1
      }), /*#__PURE__*/_react.default.createElement(_col.default, {
        className: "more-container",
        md: 2,
        xs: 3
      }, !hideCustomization && (ecardRequired && !selectedEcard ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        color: 'red',
        title: (0, _intlTools.getString)('ecard.required.toolTip')
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "required"
      }), /*#__PURE__*/_react.default.createElement(_button.default, {
        tabIndex: showEcards ? -1 : 0,
        "aria-label": (0, _intlTools.getString)('ecard.imageButton.label'),
        className: "more-picker large-circle",
        shape: "circle",
        icon: /*#__PURE__*/_react.default.createElement(_icons.Image, {
          className: "image-icon"
        }),
        onClick: this.toggleEcardPicker
      })) : /*#__PURE__*/_react.default.createElement(_button.default, {
        tabIndex: showEcards ? -1 : 0,
        "aria-label": (0, _intlTools.getString)('ecard.imageButton.label'),
        className: "more-picker large-circle",
        shape: "circle",
        icon: /*#__PURE__*/_react.default.createElement(_icons.Image, {
          className: "image-icon"
        }),
        onClick: this.toggleEcardPicker
      }))), /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 19
      }, allowUpload && !hideCustomization && /*#__PURE__*/_react.default.createElement(_button.default, {
        tabIndex: showEcards ? -1 : 0,
        "aria-label": (0, _intlTools.getString)('ecard.uploadButton.label'),
        className: "image-upload large-circle",
        shape: "circle",
        icon: /*#__PURE__*/_react.default.createElement(_icons.Upload, null),
        onClick: this.toggleDropzone
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: drawerClasses
      }, /*#__PURE__*/_react.default.createElement(_row.default, {
        justify: "right",
        className: "title-row"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 4
      }, !hideCustomization && /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "back-btn",
        "aria-label": (0, _intlTools.getString)('ecard.backButton.label'),
        icon: /*#__PURE__*/_react.default.createElement(_icons.ArrowLeft, {
          className: "ecard-back"
        }),
        onClick: selectedEcard ? this.deletePrompt : this.toggleEcardPicker
      })), /*#__PURE__*/_react.default.createElement(_col.default, {
        className: "ecard-title-text",
        span: 15
      }, !selectedEcard && /*#__PURE__*/_react.default.createElement("h4", {
        className: "bold-header"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.ecardSelect"
      })), selectedEcard && allowCustomText && /*#__PURE__*/_react.default.createElement("h4", {
        className: "bold-header"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.ecardCustomize"
      }))), /*#__PURE__*/_react.default.createElement(_col.default, {
        className: "text-right",
        span: 4
      }, selectedEcard && (!hideCustomization || isUpload) && /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "save-ecard-btn primary-background",
        "aria-label": (0, _intlTools.getString)('ecard.saveButton.label'),
        loading: saving,
        onClick: function onClick() {
          _this2.setState({
            editingText: false
          }, _this2.saveImage);
        },
        type: "primary"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.ecardSave"
      })))), /*#__PURE__*/_react.default.createElement(_row.default, {
        justify: "center"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 24
      }, selectedEcard && /*#__PURE__*/_react.default.createElement("span", null, editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "font-btn-container"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.casualButton.label'),
        className: "casual-btn",
        onClick: function onClick() {
          return _this2.changeFont('casual');
        }
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.casualButton"
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.personalButton.label'),
        className: "personal-btn",
        onClick: function onClick() {
          return _this2.changeFont('personal');
        }
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.personalButton"
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.strongButton.label'),
        className: "strong-btn",
        onClick: function onClick() {
          return _this2.changeFont('strong');
        }
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.strongButton"
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.formalButton.label'),
        className: "formal-btn",
        onClick: function onClick() {
          return _this2.changeFont('formal');
        }
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.formalButton"
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.playfulButton.label'),
        className: "playful-btn",
        onClick: function onClick() {
          return _this2.changeFont('playful');
        }
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.playfulButton"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        ref: this.renderRef,
        className: "render-image"
      }, /*#__PURE__*/_react.default.createElement("img", {
        ref: this.imageRef,
        alt: "",
        crossOrigin: "anonymous",
        onLoad: this.imageLoaded,
        className: "ecard-preview",
        src: selectedEcard && selectedEcard.images && selectedEcard.images[0].url
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "ecard-message-container",
        style: {
          position: 'absolute',
          width: '100%',
          top: 0,
          maxHeight: '465px',
          height: '100%',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }
      }, (editingText || ecardText && ecardText.length > 0) && /*#__PURE__*/_react.default.createElement("div", {
        ref: this.setEcardRef,
        onKeyUp: this.trackCursor,
        onClick: this.trackCursor,
        contentEditable: editingText,
        role: "textbox",
        onInput: this.change,
        style: {
          border: 'none',
          textAlign: 'center',
          fontSize: '26px',
          minWidth: '50%',
          maxWidth: '75%',
          resize: 'none',
          marginLeft: 'auto',
          marginRight: 'auto',
          borderRadius: '8px',
          padding: '12px',
          color: textColor,
          backgroundColor: backgroundColor,
          fontFamily: fontFamily || 'Poppins',
          fontWeight: fontWeight || 600
        },
        className: ecardTextClasses
      }))), /*#__PURE__*/_react.default.createElement(_row.default, {
        className: "ecard-actions"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 8
      }, editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "text-tools-container"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: textBackgroundSelected ? (0, _intlTools.getString)('ecard.customize.selectText') : (0, _intlTools.getString)('ecard.customize.selectBackground')
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "switch-container"
      }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
        borderRadius: 30,
        height: 40,
        width: 72,
        checked: textBackgroundSelected,
        onChange: this.toggleBackground,
        uncheckedHandleIcon: /*#__PURE__*/_react.default.createElement("span", {
          className: "foreground-toggle-btn"
        }, "T"),
        checkedHandleIcon: /*#__PURE__*/_react.default.createElement("span", {
          className: "background-toggle-btn"
        }, /*#__PURE__*/_react.default.createElement(_icons.RectWithT, {
          className: "background-toggle-btn"
        })),
        checkedIcon: false,
        uncheckedIcon: false,
        onColor: "#888"
      }))), /*#__PURE__*/_react.default.createElement(_popover.default, {
        overlayClassName: "color-picker-popover",
        trigger: "click",
        onClick: this.triggerPicker,
        visible: pickerVisible,
        getPopupContainer: function getPopupContainer() {
          return _this2.pickerButtonRef.current;
        },
        content: /*#__PURE__*/_react.default.createElement("span", {
          ref: this.popupRef
        }, /*#__PURE__*/_react.default.createElement(_reactColor.CirclePicker, {
          color: textBackgroundSelected ? backgroundColor : textColor,
          colors: _constants.PICKER_COLORS,
          onChangeComplete: textBackgroundSelected ? this.handleBackgroundColorChange : this.handleColorChange
        }))
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: (0, _intlTools.getString)('ecard.customize.editColor')
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "color-picker-btn large-circle",
        ref: this.pickerButtonRef,
        "aria-label": (0, _intlTools.getString)('ecard.editColorButton.label'),
        shape: "circle",
        icon: /*#__PURE__*/_react.default.createElement(_icons.CircleFilled, {
          fill: textBackgroundSelected ? backgroundColor : textColor
        })
      })))))), /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 8,
        lg: 10
      }), /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 2
      }, editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement(_popover.default, {
        overlayClassName: "picker-popover",
        trigger: "click",
        onClick: this.triggerEcardEmojiPicker,
        visible: ecardEmojiPickerVisible,
        content: /*#__PURE__*/_react.default.createElement("div", {
          ref: this.ecardEmojiPickerRef,
          className: "emoji-container"
        }, showEcardEmojis && /*#__PURE__*/_react.default.createElement(_emojiPickerReact.default, {
          pickerStyle: {
            fontFamily: 'Poppins, apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif'
          },
          onEmojiClick: this.emojiCardClick,
          native: true,
          groupNames: {
            smileys_people: (0, _intlTools.getString)('ecard.emoji.smileysPeople'),
            animals_nature: (0, _intlTools.getString)('ecard.emoji.animalsNature'),
            food_drink: (0, _intlTools.getString)('ecard.emoji.foodDrink'),
            travel_places: (0, _intlTools.getString)('ecard.emoji.travelPlaces'),
            activities: (0, _intlTools.getString)('ecard.emoji.activities'),
            objects: (0, _intlTools.getString)('ecard.emoji.objects'),
            symbols: (0, _intlTools.getString)('ecard.emoji.symbols'),
            flags: (0, _intlTools.getString)('ecard.emoji.flags'),
            recently_used: (0, _intlTools.getString)('ecard.emoji.recentlyUsed')
          }
        }))
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 2
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.emojiButton.label'),
        className: "edit-text-btn large-circle",
        shape: "circle",
        icon: /*#__PURE__*/_react.default.createElement(_icons.Emoticon, null)
      }))))), /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 2
      }, !editingText && imageLoaded && allowCustomText && /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.editTextButton.label'),
        className: "edit-text-btn large-circle",
        onClick: this.toggleTextEdit,
        shape: "circle",
        icon: /*#__PURE__*/_react.default.createElement(_icons.EditText, {
          fill: textColor
        })
      }), editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.finishEditButton.label'),
        className: "edit-text-btn edit-text-complete large-circle",
        type: "primary",
        shape: "circle",
        onClick: this.toggleTextEdit,
        icon: /*#__PURE__*/_react.default.createElement(_icons.Checkmark, {
          fill: '#ffffff'
        })
      }))))))), /*#__PURE__*/_react.default.createElement(_row.default, {
        className: "ecard-list"
      }, !selectedEcard && allowUpload && /*#__PURE__*/_react.default.createElement(_col.default, {
        className: "ecard-image-preview",
        onKeyPress: function onKeyPress() {
          return handleKeyPress(event, _this2.toggleDropzone);
        },
        tabIndex: selectedEcard ? -1 : 0,
        span: 4
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: this.toggleDropzone,
        className: "select-ecard-upload"
      }, /*#__PURE__*/_react.default.createElement(_icons.Upload, {
        fill: "#3f8cff",
        className: "upload-icon"
      }))), ecards && ecards.length > 0 && !selectedEcard && ecards.map(function (ecard) {
        return ecard.reward.options.map(function (option) {
          return /*#__PURE__*/_react.default.createElement(_col.default, {
            className: "ecard-image-preview",
            onKeyPress: hideCustomization ? function () {
              handleKeyPress(event, _this2.directSelectEcard, option);
            } : function () {
              return handleKeyPress(event, _this2.selectEcard, option);
            },
            tabIndex: selectedEcard ? -1 : 0,
            key: option.ecardId,
            span: 4
          }, /*#__PURE__*/_react.default.createElement("img", {
            alt: "",
            onClick: hideCustomization ? function () {
              _this2.directSelectEcard(option);
            } : function () {
              _this2.selectEcard(option);
            },
            className: "select-ecard",
            src: "".concat(_endpoints.ecardUrl, "/companies/").concat(companyId, "/ecards/").concat(option.ecardId, "/locales/").concat(locale)
          }));
        });
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: uploadDrawerClasses
      }, /*#__PURE__*/_react.default.createElement(_row.default, {
        justify: "right",
        className: "title-row"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 2
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        className: "back-btn",
        "aria-label": (0, _intlTools.getString)('ecard.backButton.label'),
        icon: /*#__PURE__*/_react.default.createElement(_icons.ArrowLeft, {
          className: "ecard-back"
        }),
        onClick: this.toggleDropzone
      })), /*#__PURE__*/_react.default.createElement(_col.default, {
        className: "ecard-title-text",
        span: 17
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "bold-header"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.upload"
      }))), /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 4
      }, selectedEcard && /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": (0, _intlTools.getString)('ecard.saveButton.label'),
        type: "primary"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.ecardSave"
      })))), /*#__PURE__*/_react.default.createElement(_spin.default, {
        spinning: this.state.imageSaving
      }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
        onDropRejected: this.dropRejected,
        onDrop: this.imageDrop,
        accept: 'image/*',
        multiple: false,
        maxSize: 31457280
      }, function (_ref5) {
        var getRootProps = _ref5.getRootProps,
            getInputProps = _ref5.getInputProps;
        return /*#__PURE__*/_react.default.createElement("div", _extends({
          className: "upload-content"
        }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", _extends({
          "aria-label": (0, _intlTools.getString)('ecard.uploadInput.label'),
          style: "display: none"
        }, getInputProps())), /*#__PURE__*/_react.default.createElement("div", {
          className: "upload-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "upload-icon-container"
        }, /*#__PURE__*/_react.default.createElement(_icons.Upload, {
          fill: "#3f8cff",
          className: "upload-icon"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "upload-text-container"
        }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
          code: "ecard.customize.uploadInstructions"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "parameter-text"
        }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
          code: "ecard.customize.uploadParameters"
        })))));
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.open === true && state.showEcards === false) {
        state.showEcards = props.open;
      }

      if (props.removeEcard && state.selectedEcard !== undefined) {
        state.selectedEcard = undefined;
        state.editingText = false;
        state.ecardText = '';
        state.fontFamily = 'Poppins', state.fontWeight = 600, state.backgroundColor = 'rgba(245, 247, 250, 0.5)', state.textColor = '#000000', state.imageLoaded = false, state.isUpload = false;
        state.saved = false;

        if (typeof props.onEcardRemoved === 'function') {
          props.onEcardRemoved();
        }
      }

      if (props.ecardState && props.ecardState.selectedEcard && !props.hideCustomization && !state.selectedEcard && !state.refUpdated) {
        state.selectedEcard = props.ecardState.selectedEcard;
        state.ecardText = props.ecardState.ecardText;
        state.fontFamily = props.ecardState.fontFamily;
        state.fontWeight = props.ecardState.fontWeight;
        state.backgroundColor = props.ecardState.backgroundColor;
        state.textColor = props.ecardState.textColor;
        state.isUpload = props.ecardState.isUpload;
      }

      return state;
    }
  }]);

  return Editor;
}(_react.default.Component);

exports.default = Editor;
//# sourceMappingURL=editor.js.map